var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8.24902C4 7.55867 4.55964 6.99902 5.25 6.99902H26.75C27.4404 6.99902 28 7.55867 28 8.24902C28 8.93938 27.4404 9.49902 26.75 9.49902H5.25C4.55964 9.49902 4 8.93938 4 8.24902ZM4 16C4 15.3096 4.55964 14.75 5.25 14.75H26.75C27.4404 14.75 28 15.3096 28 16C28 16.6904 27.4404 17.25 26.75 17.25H5.25C4.55964 17.25 4 16.6904 4 16ZM5.25 22.5C4.55964 22.5 4 23.0596 4 23.75C4 24.4404 4.55964 25 5.25 25H26.75C27.4404 25 28 24.4404 28 23.75C28 23.0596 27.4404 22.5 26.75 22.5H5.25Z",
    fill: "#1E2527"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon24X24);
export default __webpack_public_path__ + "static/media/menu_icon_24x24.40d50122d6277c05e7b9bd6f54a2ca77.svg";
export { ForwardRef as ReactComponent };